
export function getTokenBuyUrl(tokenAddress: string, whenDone: (tokenAddress: string) => void) : void {
    fetch("https://redmatter.capital/xapi/rmswap/tokens/get?id=" + tokenAddress)
        .then((response) => response.json())
        .then((response) => {
            whenDone(response.buyUrl);
        });
        //return "https://redmatter.capital/buytoken/" + tokenAddress;
}
